<template>
    <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_wrap' : 'headerIncomeWidget_wrap-minimaze'">
        <div class="headerIncomeWidget_title">
            <div class="headerIncomeWidget_text">
                Доход %
            </div>
            <des icon-class="icon icon--inline x15" icon-size="-5 0 30 30" v-show="getStatusHeader.header.minimaze" :text = "'Совокупный и средний доход в %'"></des>
        </div>
        <div class="headerIncomeWidget_balance">
                <watcher :data="commonProfit"
						 :units="'%'"
                >

				</watcher>
        </div>
        <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
            <div class="headerIncomeWidget_data" v-show="getStatusHeader.header.minimaze">
                <div class="headerIncomeWidget_dataItem">
                    <div class="headerIncomeWidget_dataItem-text">средний в месяц</div>
                    <watcher :data="averrangeProfit"
							 :units="'%'"
                    >

					</watcher>
                </div>
            </div>
        </transition>
            <!--<div v-show="getStatusHeader.header.minimaze" v-if = "incomeType[type].dataPoints != 0" class="headerIncomeWidget_dataItem"
                    :class = "(incomeType[type].dataPoints < 0) ? 'color-red' : 'color-green'">
                    {{$moneyf(incomeType[type].dataPoints,0)}} pip
            </div>
            <div class="headerIncomeWidget_maxdd"
            :class = "((incomeType[type].dataDD === 0) ? 'color-yellow' : 'color-red')">
            MAX. DD {{incomeType[type].dataDD}}%
        </div>-->
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Description from '../ui-components/description'
import Watcher from '../ui-components/ui-data-watcher'
export default {
    components: {
        'des':Description,
        'watcher':Watcher
    },
    props: {
        incomeTitle: { default: "" },
    },
    data() {
        return {
        statistic: {},
        commonProfit:0,
        averrangeProfit:0,
        filterOpenPositions: [
            { field: "symbol", dir: "asc" },
            { field: "timeEnter", dir: "asc" }
        ]
        };
    },
    computed: {
        ...mapGetters({
            getProfit:'accountstat/getMonthProfitStrategy',
            getStatusHeader:'usersets/getSettings'
        }),
        statOpenPositions() {
            let flatStat = this.$store.getters["positions/positionsFlatFiltered"](this.filterOpenPositions);
            let sumPoints = 0;
            for (let i = 0; i < flatStat.length; i++)
                sumPoints += flatStat[i].resultPoint;
            return sumPoints;
        }
    },
    methods: {
        updateStatistics(symbol) {
            let stat = this.getProfit('');
            if (!stat) {
                return;
            }
            let data = getData(stat);
            this.commonProfit = data.comProfit;
            this.averrangeProfit = data.avProfit;
        }
    },
    created() {
        subscribeOnUpdate(this.$store, "", isFirstObtained => {
                this.updateStatistics();
        });
        this.updateStatistics();
    }
    };

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "header-common-profit-widget",
            handler: handler
        }
    });
}
function sumTo(n, array) {
    let sum = 0;
    for (let i = 0; i <= n; i++)
        sum += array[i].profit;
    return sum;
}

function getData(stats) {
     let point = {
        comProfit:0,
        avProfit:0,
        pointProfit:[],
        pointLine:[]
    }
    for (let i = 0; i < stats.length; i++) {
        point.pointProfit.push(sumTo(i,stats));
        point.pointLine.push(sumTo(i, stats) / (i + 1));
    }
    point.comProfit = point.pointProfit[point.pointProfit.length - 1];
    point.avProfit = point.pointLine[point.pointLine.length - 1];
    return point;
}

</script>
<style lang="less" scoped>
@keyframes change-padding {
    from {
        padding: 8px 12px 12px 12px;
    }
    to {
        padding: 4px 12px 12px 12px;
    }
}
@keyframes change-padding-full {
    from {
        padding: 4px 12px 12px 12px;
    }
    to {
        padding: 8px 12px 12px 12px;
    }
}
.headerIncomeWidget {
  &_wrap {
    animation: change-padding-full 0.6s ease-in 1;
    display: flex;
    flex-direction: column;
    background: #3d536b;
    margin-right: 1px;
    padding: 8px 12px 12px 12px;
    flex-grow: 1;
    max-height: 88px;
    min-width: 130px;
    &-minimaze {
        animation: change-padding 0.6s ease-in 1;
        display: flex;
        flex-direction: column;
        background: #3d536b;
        margin-right: 1px;
        padding: 4px 12px 12px 12px;
        flex-grow: 1;
        height: 88px;
        min-width: 130px;
    }
  }

  &_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-height: 20px;
  }

  &_text {
    font-family: Arimo;
    font-size: 10px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: 0.4px;
    color: #ffffff;
    max-height: 16px;
    text-transform: uppercase;
  }

  &_balance {
    font-family: Arimo;
    font-size: 16px;
    //font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    color: @colors[green];
    margin-bottom: 0px;
    display: flex;
    align-items: center;
  }

  &_data {
    display: flex;
  }

  &_dataItem {
    font-family: Arimo;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: normal;
    color: #0fd7b7;
    margin-right: 4px;
    margin-top: 6px;
    &-text {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #aabed2;
    }
  }

  &_maxdd {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: 0.4px;
    color: @colors[red];
    margin-top: 4px;
  }
}
</style>
